import React from "react";
import NewsList from "components/news-list";
import Loading from "components/loading";
import NewsStreamHeader from "components/news-stream-header";
import "./blog-landing.scss";
import ArrowButton from "components/arrow-button";
import useBlogLanding from "./useBlogLanding";

const BlogLanding = ({ heading, label }) => {
  const { loading, data, loadMore, done } = useBlogLanding();

  return (
    <div className="BlogLanding">
      <NewsStreamHeader label={label} heading={heading} />
      {data && <NewsList items={data.items} />}
      <div className="BlogLanding-load">
        {loading ? (
          <Loading />
        ) : done ? (
          <div className="BlogLanding-load-message">No More</div>
        ) : (
          <ArrowButton onClick={() => loadMore()}>Load More</ArrowButton>
        )}
      </div>
    </div>
  );
};

export default BlogLanding;
